import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _taggedTemplateLiteral from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import { Ge as f, hi as m, bo as l, w as h, di as g, M as v } from "./abstract-base-8edf0a84-e11d45a3.js";
import { s as B } from "./form-base-01fb45f3-a50e84ff.js";
import { o as k, i as y } from "./helper-dd9a664c-e404f685.js";
import { A as O } from "./query-assigned-ba663908-228b08f4.js";
import "./form-associated-d3ceba31-80e8a7c4.js";
import "./utils-2e24a437-383bbd0f.js";
import "./keys-b2183e45-74d07070.js";
import "./query-24926cff-3eb94bfb.js";
var C = f(_templateObject || (_templateObject = _taggedTemplateLiteral(["label,.label{font-size:var(--beacon-form-label-font-size);font-weight:var(--beacon-form-label-font-weight);line-height:var(--beacon-form-label-font-line-height);margin:0;padding:0}.hint{font-size:var(--beacon-form-font-size);line-height:var(--beacon-form-font-line-height);margin:0}input,select,textarea{color:var(--beacon-form-field-color-text-default)}[aria-disabled=true]{caret-color:transparent;color:var(--beacon-form-field-color-text-inactive);cursor:not-allowed}fieldset{border:0;padding:0}.radio-buttons{align-items:var(--beacon-custom-radio-group-radio-buttons-align-items, initial);display:var(--beacon-custom-radio-group-radio-buttons-display, flex);flex-direction:var(--beacon-custom-radio-group-radio-buttons-flex-direction, column);gap:var(--beacon-custom-radio-group-radio-buttons-gap, 0);justify-content:var(--beacon-custom-radio-group-radio-buttons-justify-content, initial)}::slotted([beacon-tag-name=beacon-radio-button]){margin-block:10px}::slotted([beacon-tag-name=beacon-radio-button]:last-of-type){margin-block-end:0}\n"])));
var F = Object.defineProperty,
  $ = Object.getOwnPropertyDescriptor,
  c = function c(r, t, e, o) {
    for (var i = o > 1 ? void 0 : o ? $(t, e) : t, a = r.length - 1, s; a >= 0; a--) (s = r[a]) && (i = (o ? s(t, e, i) : s(i)) || i);
    return o && i && F(t, e, i), i;
  };
var u = "beacon-radio-group",
  R = ["beacon-error"];
var n = /*#__PURE__*/function (_m) {
  _inherits(n, _m);
  function n() {
    var _thisSuper, _this;
    _classCallCheck(this, n);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(n).apply(this, arguments)), _this.beaconTagName = u, _this.name = "radio", _this.reflectPropertiesOnAssigned = function (t, e) {
      e.forEach(function (o) {
        t.forEach(function (i) {
          i in o && (o[i] = _this[i]);
        });
      });
    }, _this.updateBooleanProps = function () {
      _this.radioButtons && (_this.reflectInvalidOnAssigned(), _this.reflectDisabledOnAssigned());
    }, _this.updateValueFromChecked = function () {
      _this.radioButtons && _this.radioButtons.forEach(function (t) {
        var e;
        t.checked && (_this.value = t.value, (e = _this.internals) == null || e.setFormValue(_this.value));
      });
    }, _this.validateRadioGroup = function (t) {
      if (_this.required && !_this.value && !_this.validateOneChecked(t) && !_this.disabled) {
        var e = _this.errorsMap.required || _this.defaultMessages.required;
        _this.setValidity({
          valueMissing: !0
        }, e, _this.radioGroupFormAnchor), _this.requestUpdate("invalid");
      } else _this.setValidity({
        valueMissing: !1
      }, void 0, _this.radioGroupFormAnchor), _this.requestUpdate("invalid");
    }, _this.validateOneChecked = function (t) {
      var e = 0;
      return t.forEach(function (o) {
        o.checked && (e += 1);
      }), e === 1;
    }, _this.requiredValidation = function () {
      _this.radioButtons && _this.validateRadioGroup(_this.radioButtons);
    }, _this.handleRadioGroupFocus = function (t) {
      _this.emitFocus(t);
    }, _this.handleRadioGroupInput = function (t) {
      _this.updatePreventDisabled(t), _this.emitInput(t);
    }, _this.handleRadioGroupClick = function (t) {
      _this.updatePreventDisabled(t), _this.emitClick(t);
    }, _this.handleRadioGroupChange = function (t) {
      _this.updatePreventDisabled(t), _this.emitChange(t);
    }, _this.updateValidity = function () {
      _this.invalid && _this.requiredValidation();
    }, _this.uncheckOtherButtons = function (t) {
      var e = t.target;
      e.checked = !0, _this.radioButtons && _this.radioButtons.forEach(function (o) {
        o.label !== e.label && (o.checked = !1, o.focusable = !1);
      });
    }, _this.handleSlotChange = function () {
      _this.radioButtons && _this.updateRadioButtonInternalValue();
    }, _this.updateRadioButtonInternalValue = function () {
      _this.radioButtons.forEach(function (t) {
        var e;
        (e = t.internals) == null || e.setFormValue("");
      });
    }, _this.getCheckedRadioIndex = function (t) {
      var e;
      var o = (e = t.find(function (i) {
        return i.checked;
      })) != null ? e : t[0];
      return t.indexOf(o);
    }, _this.checkOnlyLast = function () {
      if (_this.radioButtons) {
        var t = _this.radioButtons.filter(function (i) {
            return i.checked;
          }),
          e = _this.radioButtons.map(function (i) {
            return i.checked === !0;
          }).lastIndexOf(!0),
          o = _this.radioButtons[e];
        t.forEach(function (i) {
          i.checked = !1;
        }), o && (o.checked = !0);
      }
    }, _this.setFocusableOnEmpty = function () {
      _this.radioButtons.some(function (t) {
        return t.checked;
      }) || (_this.radioButtons[0].focusable = !0);
    }, _this.focusFromKey = function (t, e) {
      var o = t.key,
        i = k(o);
      if (i !== 0) {
        var a = e.filter(function (b) {
            return !b.disabled;
          }),
          s = a.length,
          p = _this.getCheckedRadioIndex(a),
          d = y(p, i, s);
        a[d].focusShadow(), a[d].radioButton.click(), _this.emitInput();
      }
    }, _this.firstUpdated = function () {
      _get((_thisSuper = _assertThisInitialized(_this), _getPrototypeOf(n.prototype)), "firstUpdated", _thisSuper).call(_thisSuper), _this.checkOnlyLast(), _this.updateValueFromChecked(), _this.setFocusableOnEmpty(), _this.updateBooleanProps();
    };
    return _this;
  }
  _createClass(n, [{
    key: "reflectInvalidOnAssigned",
    /**
     * Reflects the `invalid` state onto slotted radio-buttons
     */
    value: function reflectInvalidOnAssigned() {
      this.radioButtons && this.reflectPropertiesOnAssigned(["invalid"], this.radioButtons);
    }
    /**
     * Conditionally applies disabled to all slotted radio buttons
     * only when disabled is explicitly set on the group to prevent overriding
     * consumer disabling specifc radio button items.
     */
  }, {
    key: "reflectDisabledOnAssigned",
    value: function reflectDisabledOnAssigned() {
      this.disabled && this.radioButtons && this.reflectPropertiesOnAssigned(["disabled"], this.radioButtons);
    }
    /**
     * Sets the form and internal value to the captured event target value
     * then unchecks other radio-buttons and resets validity checking
     * @param event
     */
  }, {
    key: "captureEventValue",
    value: function captureEventValue(t) {
      this.internals && (this.value = t.target.value, this.internals.setFormValue(this.value)), this.uncheckOtherButtons(t), this.updateValidity();
    }
    /**
     * Emits a beacon-event-keydown then attempts to focus a slotted
     * beacon-radio-button and update the radio group value from the focused
     * radio-button
     * @param event
     * @event {BeaconEvents} beacon-event-keydown - emits when a keydown event would be fired
     */
  }, {
    key: "handleKeydown",
    value: function handleKeydown(t) {
      t.isTrusted && (_get(_getPrototypeOf(n.prototype), "handleKeydown", this).call(this, t), this.radioButtons && !this.disabled && (this.focusFromKey(t, this.radioButtons), this.updateValueFromChecked()));
    }
  }, {
    key: "render",
    value: function render() {
      var t, e;
      return this.requiredProps = ["label"], this.invalid = !((t = this.internals) != null && t.checkValidity()), this.updateBooleanProps(), l(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([" <fieldset name=", ">\n      <legend class=\"label\">", "</legend>\n      ", "\n      ", "\n      <div class=\"radio-buttons\">\n        <slot\n          @beacon-event-click=", "\n          @beacon-event-blur=", "\n          @beacon-event-input=", "\n          @beacon-event-focus=", "\n          @beacon-event-change=", "\n          @slotchange=", "\n          @keydown=", "\n          @blur=", "\n        ></slot>\n      </div>\n    </fieldset>"])), this.name, this.label, this.hint ? l(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<p class=\"hint\" id=\"hint\">", "</p>"])), this.hint) : h, this.invalid ? g(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["<", " message=\"", "\" id=\"error\"></", ">"])), this.getScopedTag("beacon-error"), (e = this.internals) == null ? void 0 : e.validationMessage, this.getScopedTag("beacon-error")) : h, this.handleRadioGroupClick, this.handleBlur, this.handleRadioGroupInput, this.handleRadioGroupFocus, this.handleRadioGroupChange, this.handleSlotChange, this.handleKeydown, this.handleBlur);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      var t;
      (t = this.handleDefer()) == null || t.then(function () {
        _get(_getPrototypeOf(n.prototype), "connectedCallback", _this2).call(_this2);
      });
    }
  }, {
    key: "radioGroupFormAnchor",
    /** The anchor for element internals within the group of radio buttons. */get: function get() {
      return this.radioButtons[0].formAnchor;
    }
  }], [{
    key: "styles",
    get: function get() {
      return [_get(_getPrototypeOf(n), "styles", this), C];
    }
  }]);
  return n;
}(m(B));
n.tagName = u;
n.nestedComponents = R;
c([v({
  reflect: !0
})], n.prototype, "name", 2);
c([O({
  selector: "beacon-radio-button"
}, !0)], n.prototype, "radioButtons", 2);
export { n as BeaconRadioGroup };